<template>
  <div class="erp-layout">
    <aside class="sidebar" :class="{ collapsed }">
      <div class="brand">
        <div class="brand-icon">★</div>
        <div v-if="!collapsed">
          <div class="brand-title">雄星亚克力ERP</div>
          <div class="brand-sub">展示盒工厂管理系统</div>
        </div>
      </div>
      <el-menu :default-active="$route.path" router background-color="#071b36" text-color="#d8e6ff" active-text-color="#fff" class="side-menu">
        <el-menu-item index="/dashboard"><i class="el-icon-s-home" />首页</el-menu-item>
        <el-submenu index="orders"><template slot="title"><i class="el-icon-document" /><span>订单管理</span></template>
          <el-menu-item index="/orders/list">订单列表</el-menu-item>
          <el-menu-item index="/orders/create">新增订单</el-menu-item>
          <el-menu-item index="/orders/detail/SO-20250525-001">订单详情</el-menu-item>
        </el-submenu>
        <el-submenu index="quotes"><template slot="title"><i class="el-icon-edit-outline" /><span>报价管理</span></template>
          <el-menu-item index="/quotes/auto">自动报价</el-menu-item>
          <el-menu-item index="/quotes/list">报价单列表</el-menu-item>
          <el-menu-item index="/quotes/detail/SQ-20250526-018">报价详情</el-menu-item>
        </el-submenu>
        <el-submenu index="samples"><template slot="title"><i class="el-icon-postcard" /><span>打样管理</span></template>
          <el-menu-item index="/samples/list">打样单列表</el-menu-item>
          <el-menu-item index="/samples/detail/SP-20250525-001">打样详情</el-menu-item>
        </el-submenu>
        <el-submenu index="production"><template slot="title"><i class="el-icon-data-line" /><span>生产进度</span></template>
          <el-menu-item index="/production/overview">生产进度总表</el-menu-item>
          <el-menu-item index="/production/detail/MO-20250526-001">工序时间轴</el-menu-item>
        </el-submenu>
        <el-submenu index="workshop"><template slot="title"><i class="el-icon-s-operation" /><span>车间报工</span></template>
          <el-menu-item index="/workshop/cutting">开料车间</el-menu-item>
          <el-menu-item index="/workshop/cnc">雕刻/CNC</el-menu-item>
          <el-menu-item index="/workshop/bending">热弯车间</el-menu-item>
          <el-menu-item index="/workshop/assembly">粘接组装</el-menu-item>
          <el-menu-item index="/workshop/packing">包装车间</el-menu-item>
        </el-submenu>
        <el-menu-item index="/qc"><i class="el-icon-circle-check" />质检管理</el-menu-item>
        <el-menu-item index="/inventory"><i class="el-icon-box" />库存管理</el-menu-item>
        <el-menu-item index="/purchase"><i class="el-icon-shopping-cart-2" />采购管理</el-menu-item>
        <el-submenu index="finance"><template slot="title"><i class="el-icon-money" /><span>财务管理</span></template>
          <el-menu-item index="/finance/receivable">应收款管理</el-menu-item>
          <el-menu-item index="/finance/profit">成本利润分析</el-menu-item>
        </el-submenu>
        <el-submenu index="customers"><template slot="title"><i class="el-icon-user" /><span>客户管理</span></template>
          <el-menu-item index="/customers/list">客户列表</el-menu-item>
          <el-menu-item index="/customers/detail/CUST-20230001">客户详情</el-menu-item>
        </el-submenu>
        <el-menu-item index="/after-sales"><i class="el-icon-service" />售后管理</el-menu-item>
        <el-menu-item index="/employees"><i class="el-icon-s-custom" />员工绩效</el-menu-item>
        <el-menu-item index="/master-data"><i class="el-icon-files" />基础资料</el-menu-item>
        <el-menu-item index="/settings"><i class="el-icon-setting" />系统设置</el-menu-item>
      </el-menu>
      <div class="factory-box" v-if="!collapsed">
        <div>雄星亚克力制品有限公司</div>
        <small>版本：v2.6.0</small>
      </div>
    </aside>

    <main class="main">
      <header class="topbar">
        <div class="top-left">
          <el-button icon="el-icon-s-fold" circle size="mini" @click="collapsed = !collapsed" />
          <span class="welcome">欢迎回来，老板！以下是亚克力展示盒工厂运营概览</span>
        </div>
        <div class="top-right">
          <el-input class="global-search hide-mobile" placeholder="搜索订单 / 客户 / 产品 / 单号" prefix-icon="el-icon-search" />
          <el-badge :value="12" class="item"><i class="el-icon-bell" /></el-badge>
          <el-badge :value="6" class="item"><i class="el-icon-message" /></el-badge>
          <el-avatar size="small" icon="el-icon-user-solid" />
          <span class="hide-mobile">老板</span>
        </div>
      </header>
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'AppLayout',
  data() { return { collapsed: false } }
}
</script>

<style scoped>
.erp-layout { display: flex; min-height: 100vh; }
.sidebar { width: 236px; background: #071b36; color: #fff; display: flex; flex-direction: column; transition: width .2s; }
.sidebar.collapsed { width: 72px; }
.brand { height: 68px; display: flex; align-items: center; gap: 10px; padding: 0 18px; border-bottom: 1px solid rgba(255,255,255,.08); }
.brand-icon { width: 34px; height: 34px; border-radius: 10px; display:flex; align-items:center; justify-content:center; background:#0f70ff; font-size:18px; }
.brand-title { font-size: 18px; font-weight: 800; }
.brand-sub { color: #8aa9d6; font-size: 12px; margin-top: 2px; }
.side-menu { border-right: 0; flex: 1; overflow-y: auto; }
.factory-box { margin: 12px; padding: 12px; border-radius: 12px; background: rgba(255,255,255,.06); font-size: 13px; }
.factory-box small { color: #8aa9d6; display: block; margin-top: 6px; }
.main { flex: 1; min-width: 0; }
.topbar { height: 68px; background: #fff; border-bottom: 1px solid #e8eef6; display: flex; align-items: center; justify-content: space-between; padding: 0 18px; position: sticky; top: 0; z-index: 10; }
.top-left, .top-right { display: flex; align-items: center; gap: 12px; }
.welcome { color: #53627a; }
.global-search { width: 340px; }
.item { font-size: 19px; color: #304263; }
@media (max-width: 992px) {
  .erp-layout { flex-direction: column; }
  .sidebar { width: 100%; height: auto; }
  .sidebar.collapsed { width: 100%; }
  .brand { height: 56px; }
  .factory-box { display: none; }
  .side-menu { display: flex; overflow-x: auto; overflow-y: hidden; }
  .side-menu /deep/ .el-submenu__title, .side-menu /deep/ .el-menu-item { white-space: nowrap; }
}
@media (max-width: 768px) {
  .welcome { display: none; }
  .topbar { height: 56px; padding: 0 12px; }
}
</style>
